import { motion } from 'framer-motion';
import { colors, spacing } from '@/theme';

interface CategoryHeaderProps {
  icon: string;
  title: string;
  description: string;
  progress: number;
}

export function CategoryHeader({ icon, title, description, progress }: CategoryHeaderProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
      style={{ marginBottom: spacing[5] }}
    >
      <div
        style={{
          padding: spacing[4],
          border: `1px solid ${colors.gray[100]}`,
          borderRadius: 20,
          backgroundColor: colors.white,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: spacing[3], marginBottom: spacing[3] }}>
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: 16,
              background: `linear-gradient(135deg, ${colors.primary[500]} 0%, ${colors.secondary[500]} 100%)`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 22,
              boxShadow: '0 10px 18px rgba(37, 99, 235, 0.2)',
            }}
          >
            {icon}
          </div>
          <div>
            <h2 style={{ fontSize: 20, fontWeight: 700, color: colors.gray[900], marginBottom: spacing[1] }}>
              {title}
            </h2>
            <p style={{ fontSize: 13, color: colors.gray[600], lineHeight: 1.4 }}>{description}</p>
          </div>
        </div>

        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: spacing[1] }}>
            <span style={{ fontSize: 12, color: colors.gray[500], fontWeight: 600 }}>Progreso</span>
            <span style={{ fontSize: 12, fontWeight: 700, color: colors.primary[600] }}>
              {Math.round(progress)}%
            </span>
          </div>
          <div
            style={{
              width: '100%',
              height: 8,
              backgroundColor: colors.gray[100],
              borderRadius: 999,
              overflow: 'hidden',
            }}
          >
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: `${progress}%` }}
              transition={{ duration: 0.4, delay: 0.1 }}
              style={{
                height: '100%',
                background: `linear-gradient(90deg, ${colors.primary[500]} 0%, ${colors.secondary[500]} 100%)`,
              }}
            />
          </div>
        </div>
      </div>
    </motion.div>
  );
}
